export default "__VITE_ASSET__CUBG4m_v__"